import { DollarSign } from 'lucide-react';

/**
 * "Cost Saving" hero card — top-row Daily Dashboard widget. Mirrors
 * the legacy `sec_125` two-column tile: a primary `$Money Saved`
 * value alongside a secondary `Hours Saved` value, both pulled from
 * the same per-scenario KPI rollup.
 *
 * Today the engine doesn't expose the aggregate yet, so the card
 * renders zeros with neutral styling. Once `/v1/kpi-values` lands,
 * the page wires the live totals through.
 */
export interface CostSavingCardProps {
  moneySaved: number;
  hoursSaved: number;
}

export function CostSavingCard({ moneySaved, hoursSaved }: CostSavingCardProps): JSX.Element {
  return (
    <article className="rounded-lg border border-foreground/10 bg-foreground/[0.03] p-4">
      <header className="mb-3 flex items-center gap-2 text-sm text-foreground/65">
        <span
          className="inline-flex h-7 w-7 items-center justify-center rounded-md"
          style={{ backgroundColor: 'rgba(34, 197, 94, 0.18)' }}
        >
          <DollarSign className="h-4 w-4 text-emerald-700 dark:text-emerald-300" />
        </span>
        <span className="font-medium text-foreground/85">Cost Saving</span>
      </header>
      <div className="flex items-end gap-6">
        <div>
          <div className="text-2xl font-semibold tabular-nums text-foreground">
            ${moneySaved.toLocaleString()}
          </div>
          <div className="text-xs text-foreground/50">Money Saved</div>
        </div>
        <div>
          <div className="text-2xl font-semibold tabular-nums text-foreground">
            {hoursSaved.toLocaleString()}
          </div>
          <div className="text-xs text-foreground/50">Hours Saved</div>
        </div>
      </div>
    </article>
  );
}
